import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '~/i18n-provider';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';
import { Globe } from 'lucide-react';
import { SUPPORTED_LANGUAGES } from '~/lib/i18n'; // Import the languages
// Removed unused import: import i18next from '~/lib/i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  // isHydrated is removed from context
  const { currentLanguage } = useLanguageContext();

  // Check only if i18n instance is initialized
  if (!i18n.isInitialized) {
    return null;
  }

  const changeLanguage = async (newLang: string) => {
    // Prevent changing to the same language
    if (newLang === currentLanguage) return;

    try {
      // REMOVED: No need to load languages when bundled
      // await i18n.loadLanguages(newLang);

      // Persist preference
      localStorage.setItem('i18nextLng', newLang);

      // Change language via i18next (this should trigger context update via listener)
      await i18n.changeLanguage(newLang);
    } catch (error) {
      console.error('[LanguageSwitcher] Error changing language:', error);
    }
  };

  const displayLangCode = currentLanguage.toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-1 uppercase"
          title={i18n.t('common.changeLanguage', 'Change language')} // Use translation for title
        >
          <Globe className="h-4 w-4" />
          <span className="text-xs font-medium">{displayLangCode}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LANGUAGES.map(({ code, name }) => (
          <DropdownMenuItem
            key={code}
            onClick={() => changeLanguage(code)}
            className="flex items-center justify-between"
            disabled={code === currentLanguage} // Disable current language
          >
            <span>{name}</span>
            {/* Add checkmark for the current language */}
            {code === currentLanguage && (
              <span className="ml-2 text-xs">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
